module.exports = __webpack_public_path__ + "ro.cbbecc73ba1ef21ac775.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ro.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ro.svg
// module chunks = styles